var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D5FCD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,947.8c-24.7,0-44.8-20-44.8-44.8c0-49.4-40.2-89.6-89.6-89.6H52.2c-24.7,0-44.8-20-44.8-44.8V96.9 c0-24.8,20.1-44.8,44.8-44.8h268.7c123.5,0,223.9,100.5,223.9,223.9v627C544.8,927.8,524.7,947.8,500,947.8z M96.9,723.9h268.7 c32.6,0,63.2,8.7,89.6,24.1V276.1c0-74.1-60.3-134.4-134.4-134.4H96.9V723.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,947.8c-24.7,0-44.8-20-44.8-44.8v-627c0-123.5,100.5-223.9,223.9-223.9h268.7c24.7,0,44.8,20,44.8,44.8 v671.8c0,24.8-20.1,44.8-44.8,44.8H634.4c-49.4,0-89.6,40.2-89.6,89.6C544.8,927.8,524.7,947.8,500,947.8z M679.1,141.7 c-74.1,0-134.4,60.3-134.4,134.4V748c26.4-15.3,57-24.1,89.6-24.1h268.7V141.7H679.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsBlue);
export default __webpack_public_path__ + "static/media/bookings-blue.aa33b155edfc2099e6796b32774f5a0f.svg";
export { ForwardRef as ReactComponent };